import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class DatosService {

  constructor(public http:HttpClient) { }


}

export interface crearReport{
  asignaturasx?:boolean;
  submodulosx?:boolean;
  extracurricularesx?:boolean;
  periodo?:number;
  plantel?:number;
  docente?:string;
  todosdocentes?:boolean;
}

export interface crearReportPagos{
  aspirantesx?:boolean;
  inscripcionx?: boolean;
    reinscripcionx?:boolean;
  otrosconceptosx?:boolean;
  plantel?: number;
  fachaini?: string;
    fechafin?: string;

}

